import { Logger } from '../../model/domain/logger';

export class InmemoryLogger implements Logger {
  logPageView(name?: string, url?: string): void {
    this.log(name);
    this.log(url);
  }
  startTrackPage(pageName: string): void {
    this.log(pageName);
  }
  stopTrackPage(pageName: string): void {
    this.log(pageName);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logEvent(name: string, properties?: { [key: string]: any }): void {
    this.log(name);
    this.log(properties);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
    this.log(name);
    this.log(average);
    this.log(properties);
  }
  logException(exception: Error, severityLevel?: number): void {
    this.log(exception);
    this.log(severityLevel);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logTrace(message: string, properties?: { [key: string]: any }): void {
    this.log(message);
    this.log(properties);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private log(data: any) {
    return data;
  }
}
